import { IGeneratedOrder } from '~/purchase/types';
import {
  Badge,
  Button,
  Card,
  Flex,
  FormatDeliveryDate,
  Icon,
  Row,
  Text,
  Title,
} from '@wyz/ui';
import { DateUtils } from '@wyz/utils';
import { Link } from 'react-router';
import { Trans, useLocale } from '~/common/context';
import { ValueInfoItem } from '~/purchase/components';
import { OrderHelpers, SEARCH_ROUTES } from '~/purchase/helpers';
import { ORDER_STATUS_LABEL_LOOKUP } from '~/purchase/translators';

type Props = {
  order: IGeneratedOrder;
};
const GeneratedOrderItem = ({ order }: Props) => {
  const locale = useLocale();

  return (
    <div className='mt-3'>
      <Title heading='lg' weight='bold'>
        <Trans
          i18nKey='app.purchase.orders.processed.detail.generated_order'
          values={{
            value: order.orderReference,
          }}
        />
      </Title>
      <Row justifyContent='between'>
        <div className='mt-3'>
          <Card className='mt-2'>
            <Card.Body>
              <div>
                <Row justifyContent='between'>
                  <table className='w-100'>
                    <tr>
                      <ValueInfoItem
                        title={<Trans i18nKey='app.common.quantity' />}
                        align='right'
                      >
                        <Text
                          weight='semi-bold'
                          className='text-right mt-2'
                          id='quantity'
                        >
                          {order.totalQuantity}
                        </Text>
                      </ValueInfoItem>
                      {Boolean(order.tyreLines.at(0)?.resolvedBf) && (
                        <ValueInfoItem
                          title={<Trans i18nKey='app.common.price.bf' />}
                          align='right'
                        >
                          <Text
                            heading='normal'
                            weight='semi-bold'
                            color='secondary'
                            className='mt-2 text-right'
                            id='bf'
                          >
                            {
                              // FOR ORDER WE SHOULD SAVE CURRENCY, part 2
                            }
                            <Text
                              weight='normal'
                              className='text-right mt-2'
                              id='bf'
                            >
                              {locale.formatters.money(
                                order.tyreLines.at(0)?.resolvedBf,
                                {
                                  currency: order.currency,
                                  fallback: '/',
                                },
                              )}
                            </Text>
                          </Text>
                        </ValueInfoItem>
                      )}
                      <ValueInfoItem
                        title={
                          <Trans i18nKey='app.purchase.orders.table.estimated_delivery_date' />
                        }
                        align='right'
                      >
                        <Text
                          heading='normal'
                          weight='semi-bold'
                          color='secondary'
                          className='mt-2 text-right'
                          id='delivery_date'
                        >
                          <FormatDeliveryDate
                            orderType={order.type}
                            backorderContent={
                              <Trans i18nKey='app.common.offer_type.backorder' />
                            }
                            date={order.dateDelivered}
                            format={DateUtils.DATE_FORMAT.DMY}
                            locale={locale.locale}
                          />
                        </Text>
                      </ValueInfoItem>
                      <ValueInfoItem
                        title={
                          <Trans i18nKey='app.purchase.orders.processed.detail.total_tyres_buying_price' />
                        }
                        align='right'
                      >
                        <Text
                          heading='normal'
                          weight='semi-bold'
                          color='secondary'
                          className='text-right mt-2'
                        >
                          {locale.formatters.money(order.totalExclTaxProduct, {
                            currency: order.currency,
                          })}
                        </Text>
                      </ValueInfoItem>
                      <ValueInfoItem
                        title={
                          <Trans i18nKey='app.purchase.orders.processed.detail.total_buying_price' />
                        }
                        align='right'
                      >
                        <Text
                          heading='normal'
                          weight='semi-bold'
                          color='secondary'
                          className='text-right mt-2'
                        >
                          {locale.formatters.money(order.totalExclTax, {
                            currency: order.currency,
                          })}
                        </Text>
                      </ValueInfoItem>
                      <ValueInfoItem
                        title={<Trans i18nKey='app.common.status' />}
                        align='right'
                      >
                        <Text
                          heading='normal'
                          weight='semi-bold'
                          className='text-right mt-2'
                        >
                          <Badge
                            bg={
                              OrderHelpers.ORDER_STATUS_COLOR_LOOKUP[
                                order.logisticStatusId
                              ]
                            }
                            pill
                          >
                            <Trans
                              i18nKey={
                                ORDER_STATUS_LABEL_LOOKUP[
                                  order.logisticStatusId
                                ]
                              }
                            />
                          </Badge>
                        </Text>
                      </ValueInfoItem>
                      <Flex
                        alignItems='center'
                        justifyContent='end'
                        className='mt-3'
                      >
                        <Button
                          id={`${order.orderReference}-detail`}
                          variant='link'
                          size='xs'
                          as={Link}
                          to={`${SEARCH_ROUTES.PURCHASE}/orders/${order.orderReference}`}
                        >
                          <Text
                            component={Flex}
                            heading='sm'
                            weight='semi-bold'
                            color='tertiary'
                            alignItems='center'
                            className='space-x-1'
                          >
                            <Trans i18nKey='app.common.button.visit' />
                          </Text>
                          <Icon size='sm' icon='arrow-right' />
                        </Button>
                      </Flex>
                    </tr>
                  </table>
                </Row>
              </div>
            </Card.Body>
          </Card>
        </div>
      </Row>
    </div>
  );
};

export default GeneratedOrderItem;
